module.exports = __webpack_public_path__ + "img/ANTENNA WAVES RED.c485f93.svg";